import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const GA_ID = "G-FSQKK8FK6J";

const GoogleTagManager = () => {
  const location = useLocation();
  const gtagReady = useRef(false);

  // ── Load gtag.js once (deferred) ──────────────────────────────────────────
  useEffect(() => {
    // Defer GTM until the browser is idle to avoid forced reflow blocking LCP/CLS
    const loadGTM = () => {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);

      const scriptConfig = document.createElement("script");
      scriptConfig.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_ID}', { send_page_view: false });

      `;
      document.head.appendChild(scriptConfig);
      gtagReady.current = true;

      // Fire initial page_view since the location effect already ran before gtag loaded
      window.gtag("event", "page_view", {
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
      });
    };

    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(loadGTM, { timeout: 4000 });
    } else {
      // Fallback: defer by 3 seconds for browsers without requestIdleCallback
      const timer = setTimeout(loadGTM, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  // ── Fire page_view on every route change ──────────────────────────────────
  useEffect(() => {
    if (!gtagReady.current || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

export default GoogleTagManager;
